
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 576"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#205f7f","d":"M563.5 363.6a76 76 0 00-29.4-26.1c4-53.1-12.1-97.5-36.6-99.6l-.9-.1a232.8 232.8 0 00-42.5-127.7 229.4 229.4 0 00-186.7-98.2 229.6 229.6 0 00-186.7 98.2 232 232 0 00-42.5 127.7l-.9.1c-24.9 2.2-41.2 48-36.5 102.3 4.8 54.3 28.8 96.5 53.7 94.4l81.3-7.1a26 26 0 0023.6-28.1l-12.7-144.9a26 26 0 00-28.1-23.6l-21.5 1.9a171.5 171.5 0 0131.6-88.8 168.6 168.6 0 01138.8-73.3c55.3 0 105.9 26.7 138.8 73.3a172.6 172.6 0 0131.6 88.7l-21.5-1.9a25.9 25.9 0 00-28.1 23.6l-12.7 144.9a25.4 25.4 0 006 18.9 25.7 25.7 0 0017.6 9.2l81.3 7.1c18.3 1.6 36.1-20.9 46.2-54.5 1.5 1.6 3.1 3.2 4.3 5.1 6.9 10.5 8 23.6 3 35.1l-26 59.3a49.4 49.4 0 01-45.3 29.7H428a22.1 22.1 0 00-21.1-15.9h-64.4c-12.4 0-22.4 10-22.4 22.4v26.1c0 12.4 10 22.4 22.4 22.4h64.4c10.1 0 18.3-6.8 21.1-15.9h34.7a88.4 88.4 0 0081.1-53.2l25.8-59.4a75.8 75.8 0 00-6.1-72.1z"}})])
          )
        }
      }
    